import { Language } from "../language";
import { getRoute } from "@environment/type";


export default [
  //首页
  {
    path: getRoute() + "home",
    name: "Home",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      title: Language.meta.homePage,
      requiredAuth: true,
      footerShow: true,
      headerHide: true
    }
  },
  {
    path: getRoute() + "payCompletion",
    name: "payCompletion",
    component: () => import("@/views/payment/payCompletion.vue"),
    meta: {
      title: Language.home.payCompletion,
      requiredAuth: false,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "details",
    name: "Details",
    component: () => import("@/views/main/details/Details.vue"),
    meta: {
      title: Language.home.details,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightInquiry",
    name: "FreightInquiry",
    component: () => import("@/views/main/freightInquiry/freightInquiry.vue"),
    meta: {
      title: Language.home.freightInquiry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightInquiryDetail",
    name: "freightInquiryDetail",
    component: () => import("@/views/main/freightInquiry/freightInquiryDetail.vue"),
    meta: {
      title: Language.home.freightInquiryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderDetail",
    name: "orderDetail",
    component: () => import("@/views/main/orderDetail/orderDetail.vue"),
    meta: {
      title: Language.home.orderDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderException",
    name: "orderException",
    component: () => import("@/views/main/orderException/orderException.vue"),
    meta: {
      title: Language.home.orderException,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "paybillList",
    name: "paybillList",
    component: () => import("@/views/main/paybill-list/paybill-list.vue"),
    meta: {
      title: Language.paybillList.payableBills,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoInquiryList",
    name: "cargoInquiryList",
    component: () => import("@/views/main/cargoInquiry/cargoInquiry-list.vue"),
    meta: {
      title: Language.home.cargoInquiry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoInquiry",
    name: "cargoInquiry",
    component: () => import("@/views/main/cargoInquiry/cargoInquiry.vue"),
    meta: {
      title: Language.home.cargoInquiry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsForecast",
    name: "goodsForecast",
    component: () => import("@/views/main/goodsForecast/goodsForecast.vue"),
    meta: {
      title: Language.home.goodsForecast,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountList",
    name: "accountList",
    component: () => import("@/views/main/accountList/accountList.vue"),
    meta: {
      title: Language.home.accountList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "shippingAddress",
    name: "shippingAddress",
    component: () => import("@/views/main/shippingAddress/shippingAddress.vue"),
    meta: {
      title: Language.home.shippingAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "editAddress",
    name: "EditAddress",
    component: () => import("@/views/main/edit-address/EditAddress.vue"),
    meta: {
      title: Language.address.addAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "editAddress/:id",
    name: "EditAddress",
    component: () => import("@/views/main/edit-address/EditAddress.vue"),
    props: true,
    meta: {
      title: Language.address.editAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightPriceCalculator",
    name: "freightPriceCalculator",
    component: () => import("@/views/main/freightPriceCalculator/freightPriceCalculator.vue"),
    meta: {
      title: Language.home.freightPriceCalculator,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "kefuList",
    name: "kefuList",
    component: () => import("@/views/main/kefu/kefuList.vue"),
    meta: {
      title: Language.meta.kefuList,
      stickyHeader: true,
    }
  },
  // 用户中心
  {
    path: getRoute() + "user",
    name: "User",
    component: () => import("@/views/user/Index.vue"),
    children: [
      {
        path: "",
        redirect: getRoute() + "user/userManage"
      },
      {
        path: getRoute() + "user/userManage",
        name: "UserManage",
        component: () => import("@/views/user/user-manage/UserManage.vue"),
        meta: {
          title: Language.meta.userManagement,
          footerShow: true,
          headerHide: true
        }
      },
      {
        path: getRoute() + "user/editInformation",
        name: "EditInformation",
        component: () => import("@/views/user/edit-information/edit-information.vue"),
        meta: {
          title: Language.information.title,
          stickyHeader: true,
        }
      },
      {
        path: getRoute() + "user/pointsList",
        name: "PointsList",
        component: () => import("@/views/user/pointsList/pointsList.vue"),
        meta: {
          title: Language.home.pointsList,
          stickyHeader: true,
        }
      },
    ]
  },
  {
    path: getRoute() + "auth",
    component: _ => import("@/views/main/auth/Index.vue"),
    children: [
      {
        path: "",
        redirect: getRoute() + "auth/login"
      },
      {
        path: getRoute() + "auth/login",
        name: "Login",
        component: _ => import("@/views/main/auth/Login.vue"),
        meta: {
          title: Language.auth.login,
          headerHide: true
        }
      },
      {
        path: getRoute() + "auth/register",
        name: "Register",
        component: _ => import("@/views/main/auth/Register.vue"),
        meta: {
          title: Language.auth.register,
          headerHide: true
        }
      },
      {
        path: getRoute() + "auth/regInfo",
        name: "RegisterInfo",
        component: _ => import("@/views/main/auth/RegisterInfo.vue"),
        meta: {
          title: Language.auth.setAccountInfo,
          headerHide: true
        }
      },
    ]
  },
  {
    path: getRoute() + "privacy1",
    name: "privacy1",
    component: () => import("@/views/privacy/privacy1.vue"),
    meta: {
      title: Language.meta.privacy1,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "privacy2",
    name: "privacy2",
    component: () => import("@/views/privacy/privacy2.vue"),
    meta: {
      title: Language.meta.privacy2,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "privacy3",
    name: "privacy3",
    component: () => import("@/views/privacy/privacy3.vue"),
    meta: {
      title: Language.meta.privacy3,
      stickyHeader: true,
    }
  },
];
